import React from 'react';

type ConnectionsProps = {
  width?: string;
  height?: string;
  stroke?: string;
  fill?: string;
  strokeWidth?: string;
};

function Connections({
  width = '21',
  height = '22',
  stroke = '#6267AC',
  fill = 'none',
  strokeWidth = '2',
}: ConnectionsProps) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 24 25'
      fill={fill}
    >
      <path
        d='M19.9795 1.91431L18 3.89385'
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
      />
      <path
        d='M4.91306 10.5103L10.9898 16.587'
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
      />
      <path
        d='M9.37851 14.9758L11.6527 12.7015M8.79844 9.80129L6.47825 11.9834M1.32224 20.0857L3.48592 18.0602'
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
      />
      <path
        d='M3.4399 13.1342L5.46548 11.1086L10.3453 15.9884L8.3197 18.014C6.97218 19.3615 4.78742 19.3615 3.4399 18.014C2.09238 16.6665 2.09238 14.4817 3.4399 13.1342Z'
        stroke={stroke}
        strokeWidth={strokeWidth}
      />
      <path
        d='M10.5424 6.03177L13.0946 3.47954C14.1879 2.38627 15.9604 2.38627 17.0537 3.47954L17.9744 4.40026C19.0931 5.51895 19.0931 7.33272 17.9744 8.45141L15.3087 11.1171C15.1792 11.2466 14.9692 11.2466 14.8396 11.1171L10.5424 6.8199C10.3248 6.60226 10.3248 6.2494 10.5424 6.03177Z'
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
      />
    </svg>
  );
}

export default Connections;
